export enum EQuoteError {
  INVALID_FIELDS = 'InvalidFields',
  NOT_FOUND = 'NotFound',
  BOOKING_ADVANCE_NOTICE_REQUIRED = 'BookingAdvanceNoticeRequired',
  MINIMUM_DAYS_LENGTH = 'MinimumDaysLength',
}
